import React from 'react';
import { AlertTriangle, Copy, Eye, Loader2 } from 'lucide-react';

const STATUS_LABELS = {
  in_review: 'in review',
  approved: 'approved',
  published: 'published',
};

const PublishedWarningModal = ({
  showPublishedWarningModal,
  setShowPublishedWarningModal,
  creatingNewVersion,
  handleCreateNewVersion,
  onBack,
  isSuperuser = false,
  onOpenReadOnly,
  publicationStatus
}) => {
  if (!showPublishedWarningModal) return null;

  const statusLabel = STATUS_LABELS[publicationStatus] || 'locked';

  return (
    <div className="fixed inset-0 bg-gray-950/40 dark:bg-black/70 flex items-center justify-center z-50">
      <div className="max-w-md w-full overflow-hidden rounded-xl bg-white shadow-overlay ring-1 ring-gray-900/5 dark:bg-gray-800 dark:ring-white/10">
        <div className="flex items-center gap-2.5 border-b border-gray-100 px-6 py-4 dark:border-white/[0.06]">
          <AlertTriangle className="h-5 w-5 flex-shrink-0 text-warning-600 dark:text-warning-400" />
          <h2 className="text-base font-semibold text-gray-900 dark:text-gray-50">Locked Assessment</h2>
        </div>

        <div className="space-y-3 px-6 py-5">
          <p className="text-sm text-gray-700 dark:text-gray-300">
            This assessment is {statusLabel} and locked. To make changes, create a new draft version.
          </p>
          <div className="rounded-lg border border-gray-200 bg-gray-50 px-4 py-3 dark:border-white/[0.06] dark:bg-white/[0.02]">
            <h3 className="mb-1 text-sm font-medium text-gray-900 dark:text-gray-100">To make changes:</h3>
            <p className="text-sm text-gray-600 dark:text-gray-300">
              Create a new draft version which will copy all content from this version.
              The current version is preserved unchanged so any study still using it is unaffected.
            </p>
          </div>
        </div>

        <div className="flex flex-wrap items-center justify-end gap-2 border-t border-gray-100 bg-gray-50/70 px-6 py-3.5 dark:border-white/[0.06] dark:bg-white/[0.02]">
          <button
            onClick={() => {
              setShowPublishedWarningModal(false);
              onBack();
            }}
            className="btn btn-secondary"
          >
            Go Back
          </button>
          <button
            onClick={() => {
              setShowPublishedWarningModal(false);
              handleCreateNewVersion();
            }}
            disabled={creatingNewVersion}
            className="btn btn-primary"
          >
            {creatingNewVersion ? (
              <>
                <Loader2 className="w-4 h-4 animate-spin" />
                Creating...
              </>
            ) : (
              <>
                <Copy className="w-4 h-4" />
                Create New Version
              </>
            )}
          </button>
        </div>

        {isSuperuser && onOpenReadOnly && (
          <div className="border-t border-gray-100 bg-gray-50/70 px-6 py-2.5 dark:border-white/[0.06] dark:bg-white/[0.02]">
            <button
              onClick={onOpenReadOnly}
              className="w-full text-xs text-gray-500 hover:text-gray-900 dark:text-gray-400 dark:hover:text-gray-100 transition-colors flex items-center justify-center gap-1.5"
            >
              <Eye className="w-3.5 h-3.5" />
              Superuser: Open Read-Only
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default PublishedWarningModal;
